define([
    'WebCommon/api'
], function(
    CommonApi
){
    var Api = CommonApi.Api;
    return {
        getSlideApi: new Api('/s/sitebanner/getSlideByType'),

        getAllFnjiBrand: new Api('/m/s/MagazineBrand/getAll'),

        getAllJobs: new Api('/m/s/sitejob/getJobByCategory'),

        getAllShops: new Api('/m/s/sitestore/getAll'),

        getDeliver: new Api('/s/mallsetting/getDeliver'),
        getService: new Api('/s/mallsetting/getService'),

        getShopCommon: new Api('/getShopCommon'),
        getProductsByBomApi: new Api('/s/product-list/getByBom'),





        homeGalleryApi: new Api('/s/gallery/getHomeData'),
        getProductDetailApi: new Api('/s/shop/product/getDetail'),
        getProductListApi: new Api('/s/product-list/getByCategory'),

        searchProductsApi: new Api('/s/shop/product/search'),

        getBrandDetailV2: new Api('/s/gallery/getBrandDetailV2'),
        getExhibit: new Api('/m/s/fnjiexhibit/get'),

        applyExhibit: new Api('/s/exhibithis/apply'),


        getInterview: new Api('/m/s/fnjiinterview/get'),

        addCartApi: new Api('/s/cart/add-goods'),

        // getBrandGcrApi: new Api('http://fnji.com/s/brand/getBrandGcr'),//品牌
        // getByBrandApi: new Api('http://fnji.com/s/product-list/getByBrand'),//品牌详情页
        getBrandGcrApi: new Api('/s/brand/getBrandGcr'),//品牌
        getByBrandApi: new Api('/s/product-list/getByBrand'),//品牌详情页


    };
});


//////////////////
// WEBPACK FOOTER
// ./common/api.js
// module id = 108
// module chunks = 3 7 8 12 16